import { render, staticRenderFns } from "./AppSwiper.vue?vue&type=template&id=54b39fc8&scoped=true&"
import script from "./AppSwiper.vue?vue&type=script&lang=js&"
export * from "./AppSwiper.vue?vue&type=script&lang=js&"
import style0 from "./AppSwiper.vue?vue&type=style&index=0&id=54b39fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b39fc8",
  null
  
)

export default component.exports